import { render, staticRenderFns } from "./ivyobjectD.vue?vue&type=template&id=17490bd6&"
import script from "./ivyobjectD.vue?vue&type=script&lang=js&"
export * from "./ivyobjectD.vue?vue&type=script&lang=js&"
import style0 from "./ivyobjectD.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports